<template>
  <v-container>
    <TopBar />

    <v-layout align-center justify-center row fill-height>
      <v-card class="style1">
        <v-img :src="image1" aspect-ratio="2.75"></v-img>
        <v-card-title>Te damos la bienvenida a Gestión 2030, como es tu primera vez, es necesario que cambies tu contraseña.</v-card-title>

        <v-card-actions>
          <v-container>
            <v-layout row>
              <v-flex sx8>
                <form>
                  <div class="input-group">
                    <span class="input-group-addon">
                      <i class="glyphicon glyphicon-lock"></i>
                    </span>
                    <input
                      id="password"
                      type="password"
                      class="form-control"
                      name="password"
                      v-model="password"
                      placeholder="Ingrese su contraseña nueva contraseña"
                    />
                  </div>
                  <div class="input-group">
                    <span class="input-group-addon">
                      <i class="glyphicon glyphicon-lock"></i>
                    </span>
                    <input
                      id="repassword"
                      type="password"
                      class="form-control"
                      name="repassword"
                      v-model="repassword"
                      placeholder="Reingrese nueva contraseña"
                    />
                  </div>
                </form>
              </v-flex>
            </v-layout>
            <v-btn color="#EB7704" @click="sendResquest" :loading="loading">Entrar</v-btn>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-layout>
    <Footer />
  </v-container>
</template>


<script>
import image1 from "../../assets/CABECERA LOGIN.png";
import Footer from "../template/Footer";
import TopBar from "../template/TopBar";
import VueJwtDecode from "vue-jwt-decode";
import jwtDecode from "jwt-decode";

export default {
  components: {
    TopBar,
    Footer
  },
  data() {
    return {
      image1: image1,
      email: this.$session.get("email"),
      repassword: "",
      password: "",
      loading: false,
      error: false,
      auth: {
        headers: { Authorization: "" + this.$session.get("jwt") }
      }
    };
  },

  mounted() {
    //console.log(this.$session.getAll().first);
    if (this.$session.getAll().first == "no") {
      alert("no puedes ingresar a esta ruta");
      this.logout();
    }
  },

  methods: {
    logout() {
      this.$session.destroy();
      this.$router.push("/");
    },
    sendResquest() {
      this.loading = true;
      //console.log(this.mail)
      const config = {
        onDownloadProgress: function(progressEvent) {
          var percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
        }
      };

      if (this.password == "" || this.repassword == "") {
        alert("Las contraseñas no pueden ser vacias");
        this.loading = false;
      } else {
        if (this.password == this.repassword) {
          const newUser = {
            email: this.email,
            password: this.password
          };
          axios
            .post(
              process.env.ROOT_API + "/user/changePassword",
              newUser,
              this.auth
            )
            .then(response => {
              //console.log(response.data);
              alert("El cambio ha sido exitoso");
              this.logout();
            })
            .catch(error => {
              //console.log(error.response);
              if (error.response.status == 400) {
                alert(
                  "No puedes utilizar tu contraseña actual, intenta nuevamente"
                );
                this.password = "";
                this.repassword = "";
                this.loading = false;
              } else {
                alert(error);
                this.loading = false;
              }
            });
        } else {
          alert("Las contraseñas no coinciden");
          this.loading = false;
        }
      }
    }
  }
};
</script>

<style scoped>
.style1 {
  width: 50%;
}

.v-card__actions .v-btn,
.v-card__actions > * {
  margin-top: 5%;
}
</style>



// WEBPACK FOOTER //
// src/components/inicio/ChangePassword.vue